import { Typography } from '@mui/material'
import { useScreenSize } from '../../../../../../sharedComponents/src/hooks/useScreenSize'

type Props = {
    change: number
}

export const RatingChange = ({ change }: Props) => {
    const { isMobile } = useScreenSize()
    if (change === 0) {
        return null
    }

    const negative = change < 0

    return (
        <Typography
            fontFamily="Space Grotesk"
            fontWeight={700}
            variant={isMobile ? 'body2' : 'body1'}
            sx={{ color: negative ? '#FD1212' : '#73F844' }}
        >
            {negative ? '' : '+'}
            {change}
        </Typography>
    )
}
